function stripCreatablePrefix(label) {
	return String(label ?? "")
		.replace(/^Crear\s+/i, "")
		.trim();
}

export function parseEstatesFromForm(rawEstates) {
	const existingIds = [];
	const newNames = [];

	if (!Array.isArray(rawEstates)) {
		return { existingIds, newNames };
	}

	rawEstates.forEach((item) => {
		let rawValue = item;
		let rawLabel = "";

		if (item != null && typeof item === "object") {
			rawValue = item.value ?? item.id;
			rawLabel = item.label ?? "";
		}

		const numericId = Number(rawValue);
		if (!Number.isNaN(numericId) && numericId > 0) {
			existingIds.push(numericId);
			return;
		}

		const name = stripCreatablePrefix(rawLabel || rawValue);
		if (name) {
			newNames.push(name);
		}
	});

	return { existingIds, newNames };
}

export function mergeCommaSeparatedIds(currentValue, ...idsToAdd) {
	const merged = new Set();

	if (currentValue) {
		String(currentValue)
			.split(",")
			.map((part) => part.trim())
			.filter((part) => part && Number(part) !== 0)
			.forEach((part) => merged.add(Number(part)));
	}

	idsToAdd
		.flat()
		.filter((id) => id != null && id !== "" && Number(id) !== 0)
		.forEach((id) => merged.add(Number(id)));

	return Array.from(merged).join(",");
}

export function normalizeEstateIdsFromForm(rawEstates) {
	return parseEstatesFromForm(rawEstates).existingIds;
}

export function collectEstateIdsForParent({ estateParentId, estateIds = [], userEstates = [] }) {
	const collected = new Set();

	const pushId = (id) => {
		const numericId = Number(id);
		if (!Number.isNaN(numericId) && numericId > 0) {
			collected.add(numericId);
		}
	};

	normalizeEstateIdsFromForm(estateIds).forEach(pushId);

	if (Array.isArray(estateIds)) {
		estateIds.forEach((estate) => {
			if (estate != null && typeof estate === "object") {
				pushId(estate.value ?? estate.id);
			}
		});
	}

	if (estateParentId != null && estateParentId !== "") {
		userEstates.filter((estate) => String(estate.estate_parent_id) === String(estateParentId)).forEach((estate) => pushId(estate.value));
	}

	return Array.from(collected);
}

export function mergeListFiltersWithNewIds(filters, { estateParentId, estateIds } = {}) {
	const next = { ...filters };

	if (estateParentId != null && estateParentId !== "") {
		next.estate_parent_id = mergeCommaSeparatedIds(filters?.estate_parent_id, estateParentId);
	}

	const normalizedEstateIds = Array.isArray(estateIds) ? collectEstateIdsForParent({ estateIds }) : normalizeEstateIdsFromForm(estateIds);

	if (normalizedEstateIds.length) {
		next.estate_id = mergeCommaSeparatedIds(filters?.estate_id, ...normalizedEstateIds);
	}

	return next;
}

export function buildEstatesAccessEntries({ estateIds, estateParentId, estateOptions = [], newNames = [], savedEstateLabels = {} }) {
	const parentId = estateParentId != null ? String(estateParentId) : "";
	const pendingNames = [...newNames];
	const seen = new Set();

	return estateIds
		.map((estateId) => {
			const numericValue = Number(estateId);
			if (Number.isNaN(numericValue) || numericValue <= 0 || seen.has(numericValue)) {
				return null;
			}
			seen.add(numericValue);

			const fromOption = estateOptions.find((option) => Number(option.value) === numericValue);
			const fromSaved = savedEstateLabels[numericValue] ?? savedEstateLabels[estateId];
			const label = fromOption?.label || stripCreatablePrefix(fromSaved) || stripCreatablePrefix(pendingNames.shift()) || "";

			return {
				value: numericValue,
				label,
				estate_parent_id: parentId,
			};
		})
		.filter(Boolean);
}
